import get from './methodGet';
import post from './methodPost';
import put from './methodPut';

export default { ...get, ...post, ...put };
